import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Badge, Box, Button, Image, MenuButton, Paragraph, Spinner, Text, useColorMode } from "theme-ui";
import { getHistoryByView, GetTimeByProjectId, getAllContracts, getSowChecklist } from '../../store/actions/project.action';
import activity from "../assets/images/Icon/activity.svg";
import spent from "../assets/images/Icon/spent.svg";
import ProjectAction from "./ProjectAction";
import UpdateStatusToAny from "../Actions/UpdateStatusToAny";
import ThreadModalPop from "../ThreadModalPop/ThreadModalPop";
import { bucketUrl } from "../../utils/global";
import HistoryAction from "./HistoryAction";
import { projectStatuslist } from "../../utils/constent";
import { RootState, usersProps } from '../../../@types';
import theme from "../../theme";
import InfiniteScroll from "react-infinite-scroll-component";
import ActivityHistoryModal from "../pages/demotable/ActivityHistoryModal";
import ActivityRevertHistory from "../pages/demotable/ActivityRevertHistory";
import { ContractsListModal } from "./ContractsListModal";
import { getAllUserWithoutPagination } from "../../store/actions/user.action";
import { LuFileText } from 'react-icons/lu';
import { AllActivities, getUserName } from "../../utils/activityHistoryHelper";

const ProjectSideActions: React.FC<any> = ({ isTracking, elapsedTime, timeTaken, projectId }) => {
    const { historyView, spentTime, historyLoader } = useSelector((state: any) => state.project);
    const [items, setItems] = useState<any[]>([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const lastFetchRef = useRef("");
    const fetchingRef = useRef("");
    const [showAll, setShowAll] = useState(false);
    const { auther } = useSelector((state: RootState) => state.auth);
    const { dataForTable } = useSelector((state: any) => state.masterData);
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [historyModalOpen, setHistoryModalOpen] = useState<boolean>(false);
    const [isContractsListOpen, setIsContractsListOpen] = useState<boolean>(false);

    const { getproject, createprojectMasterData, SowChecklist } = useSelector((state: any) => state.project);
    const { userData } = useSelector((state: RootState) => state.user);
    const salesReps = (userData?.data || []).filter((user: usersProps) =>
        user?.departments?.some((dept: { name: string }) => dept?.name === 'SALES')
    );
    const is_Super_Admin = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "super admin");
    const isUserInMasterData = (userId: string) => {
        if (!userId) return false;
        return (
            dataForTable?.data?.allProjectManagers?.some((u: { _id: string }) => u._id === userId) ||
            dataForTable?.data?.allProjectWorkers?.some((u: { _id: string }) => u._id === userId) ||
            dataForTable?.data?.allTaskManagers?.some((u: { _id: string }) => u._id === userId) ||
            dataForTable?.data?.allTaskWorkers?.some((u: { _id: string }) => u._id === userId)
        );
    };
    const allowRoles = auther?.Role?.map(role => role?.RoleName).some(role => role.toLocaleLowerCase() === "super admin" || role.toLocaleLowerCase() === "Region Admin");
    const limit = 25;
    const next = pageNumber + 1;

    const view = 'project';
    const [selectedTab, setSelectedTab] = useState('activity');
    const handleTabClick = (tab: any) => {
        const wasAlreadyActive = tab === 'activity' && selectedTab === 'activity';
        setSelectedTab(tab);
        if (tab === 'activity') {
            setPageNumber(1);
            setItems([]);
            setHasMore(true);
            fetchingRef.current = "";
            lastFetchRef.current = "";
            if (wasAlreadyActive) {
                const currentPayload = `projectId=${projectId}&page=1&limit=${limit}`;
                fetchingRef.current = currentPayload;
                lastFetchRef.current = currentPayload;
                dispatch(getHistoryByView(currentPayload));
            }
        }
    };

    const dispatch = useDispatch();
    useEffect(() => {
        setPageNumber(1);
        setItems([]);
        setHasMore(true);
        fetchingRef.current = "";
        lastFetchRef.current = "";
    }, [projectId]);

    useEffect(() => {
        if (!SowChecklist || !SowChecklist.length) {
            dispatch(getSowChecklist());
        }
    }, [dispatch, SowChecklist]);

    useEffect(() => {
        if (isContractsListOpen && (!userData || !userData.data)) {
            dispatch(getAllUserWithoutPagination());
        }
    }, [dispatch, isContractsListOpen, userData]);

    useEffect(() => {
        if (historyView === null) {
            setPageNumber(1);
            setItems([]);
            setHasMore(true);
            fetchingRef.current = "";
            lastFetchRef.current = "";
        }
    }, [historyView === null]);

    useEffect(() => {
        const currentPayload = `projectId=${projectId}&page=${pageNumber}&limit=${limit}`;
        if (selectedTab === 'activity' && currentPayload !== fetchingRef.current) {
            if (currentPayload !== lastFetchRef.current || historyView === null) {
                dispatch(getHistoryByView(currentPayload));
                fetchingRef.current = currentPayload;
                lastFetchRef.current = currentPayload;
            }
        }
    }, [dispatch, pageNumber, projectId, selectedTab]);

    useEffect(() => {
        if (historyView?.data && !historyLoader) {
            fetchingRef.current = ""; // Reset fetching ref on success
            if (pageNumber === 1) {
                setItems(historyView?.data);
            } else {
                setItems((prevItems) => [...prevItems, ...historyView?.data]);
            }
            if (historyView?.count !== undefined) {
                setTotalItems(historyView?.count);
            }

            if ((historyView?.data?.length || 0) < limit) {
                setHasMore(false);
            } else {
                setHasMore(true);
            }
        }
    }, [historyView?.data, pageNumber, projectId, historyLoader]);

    const fetchMoreData = () => {
        if (items?.length >= totalItems) {
            setHasMore(false);
            return;
        }
        const nextPage = pageNumber + 1;
        setPageNumber(nextPage);
    };

    useEffect(() => {
        dispatch(GetTimeByProjectId(projectId));
    }, [dispatch, projectId])
    useEffect(() => {
        if (isTracking) {
            setSelectedTab('spent');
        }
    }, [isTracking]);
    function convertMillisecondsToHoursMinutesSeconds(milliseconds: number) {
        let seconds = Math.floor(milliseconds / 1000);
        const days = Math.floor(seconds / 86400);
        seconds %= 86400;
        const hours = Math.floor(seconds / 3600);
        seconds %= 3600;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;
        return { days, hours, minutes, seconds };
    }
    const [colorMode] = useColorMode();
    const titleHeader = colorMode === 'light' ? "#0a0a0a" : "#dadada";

    const toggleModal = () => setModalOpen(!modalOpen);
    const toggleHistoryModal = () => setHistoryModalOpen(!historyModalOpen);

    const getUserProfileIcon = (firstName: string, lastName: string) => {
        const firstLetter = firstName.charAt(0).toUpperCase();
        const lastLetter = lastName.charAt(0).toUpperCase();
        return <div style={{
            backgroundColor: "#7743DB",
            color: "#fff",
            width: '50px',
            height: '40px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            {firstLetter.charAt(0).toUpperCase()}{lastLetter.charAt(0).toUpperCase()}
        </div>
    }
    return (
        <>
            <div className='col-md-3 p-3' style={{ maxHeight: "750px", borderLeft: `2px solid ${theme?.colors?.lightbackground}`, overflowY: "auto" }} >
                {selectedTab === 'activity' && (
                    <>
                        <div>
                            <h5>Activity</h5>
                            <p style={{ color: titleHeader }}>All Activities</p>
                        </div>

                        <div>
                            {items?.length === 0 && historyLoader ? (
                                <Box sx={{ textAlign: 'center', mt: 4 }}>
                                    <Spinner />
                                </Box>
                            ) : (
                                <InfiniteScroll
                                    dataLength={items?.length || 0}
                                    next={fetchMoreData}
                                    hasMore={hasMore}
                                    loader={<Box sx={{ textAlign: "center" }}><Spinner /></Box>}
                                    height={600}
                                    endMessage={<p ></p>}
                                >
                                    {(() => {
                                        const seenTexts = new Set<string>();
                                        return items?.map((history: any, historyIndex: number) => {
                                            const activityText = AllActivities(
                                                history?.action,
                                                history?.changes ? { ...history?.changes, stageId: history?.stageId || history?.changes?.stageId, taskId: history?.taskId || history?.changes?.taskId } : (history?.stageId || history?.taskId ? { stageId: history?.stageId, taskId: history?.taskId } : history?.changes),
                                                history?.oldData ? { ...history?.oldData, stageId: history?.stageId || history?.oldData?.stageId, taskId: history?.taskId || history?.oldData?.taskId } : (history?.stageId || history?.taskId ? { stageId: history?.stageId, taskId: history?.taskId } : history?.oldData),
                                                dataForTable?.data?.allProjectManagers, dataForTable?.data?.allTaskManagers, dataForTable?.data?.allProjectWorkers, dataForTable?.data?.allTaskWorkers, dataForTable?.data?.allHighlighters, dataForTable?.data?.allArchitects, false, dataForTable?.data?.allStages, dataForTable?.data?.allTask?.data || dataForTable?.data?.allTask || dataForTable?.data?.allTasks || createprojectMasterData?.allTask?.data, createprojectMasterData?.allTaskSow?.data || createprojectMasterData?.allTaskSow || [createprojectMasterData, SowChecklist, dataForTable?.data]);
                                            if (!activityText) return null;
                                            const timeKey = history?.createdAt ? moment(history.createdAt).format('YYYY-MM-DD-HH:mm') : historyIndex;
                                            const normalized = `${timeKey}_${activityText.toLowerCase().replace(/['"\s_-]/g, '')}`;
                                            if (seenTexts.has(normalized)) return null;
                                            seenTexts.add(normalized);
                                            return (
                                                <div key={historyIndex + 1} style={{ flexWrap: 'wrap' }}>
                                                    <Paragraph style={{ gap: 2, marginRight: '5px' }} variant="activityText">
                                                        <strong style={{ marginRight: '6px' }}>{getUserName(history?.changes?.updatedBy || history?.changes?.updateObject?.updatedBy || history?.changes?.createdBy || history?.updatedBy || history?.createdBy, dataForTable?.data)}</strong>
                                                        {' '}{activityText}
                                                    </Paragraph>
                                                    <Paragraph sx={{ textAlign: "end", fontSize: "10px", color: "#D3D5D9", marginBottom: "0px" }}>{moment(history?.createdAt).format('MMM DD, LT')}</Paragraph ></div>);
                                        });
                                    })()}
                                </InfiniteScroll>
                            )}
                        </div>
                    </>
                )}
                {selectedTab === 'thread' && (
                    <div>
                        <h5>Chat section</h5>
                        <p className='text-muted'>All Chats</p>
                    </div>
                )}
                {selectedTab === 'spent' && (
                    <>
                        <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                            <div className="text-center">
                                <h5>Time Tracking</h5>
                                <p style={{ color: colorMode === 'light' ? "muted" : "#fff" }}>Spend history</p>
                            </div>
                            <MenuButton aria-label="Toggle Menu" />
                        </div>
                        <div className="text-center">
                            {isTracking !== null && <>
                                <p>Tracking Started</p>
                                <h1>{elapsedTime}</h1>
                            </>
                            }
                        </div>
                        <hr />

                        <div className="container-fluid">
                            <div className="row mb-4">
                                <div className="col-md-8"><h5>Last Actions<Badge variant='circle' mt={-3}>{spentTime?.length}</Badge></h5></div>
                                <div className="col-md-4">
                                    {spentTime?.length > 5 && (
                                        <div>
                                            {showAll ? (
                                                <Button variant="spentButton" onClick={() => setShowAll(false)}>Show Less</Button>
                                            ) : (
                                                <Button variant="spentButton" onClick={() => setShowAll(true)}>Show All</Button>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div style={{ maxHeight: '675px', overflow: 'auto' }}>
                                {showAll ? (
                                    spentTime?.map((time: any, index: React.Key | null | undefined) => {
                                        const { hours, minutes, seconds, days } = convertMillisecondsToHoursMinutesSeconds(time?.timeTaken);
                                        const formattedDay = days > 0 ? `${days}d` : "";
                                        const formattedHours = hours > 0 ? `${hours}h` : "";
                                        const formattedMinutes = minutes > 0 ? `${minutes}m` : "";
                                        const formattedSeconds = seconds > 0 ? `${seconds}s` : "";
                                        const profileImage = `${bucketUrl}${time?.userId?.ProfileImage}`;
                                        const userId = time?.userId?._id || time?.userId;
                                        const showUser = userId && isUserInMasterData(userId);

                                        return (
                                            <div className="spenttime" key={index}>
                                                <div className="conatainer-fluid">
                                                    <div className="row">
                                                        <div className="col-md-2 m-0 d-flex">
                                                            {showUser ? (time?.userId?.ProfileImage ? <Image src={`${bucketUrl}${time?.userId?.ProfileImage}`} alt="" style={{ width: "50px", height: "40px", borderRadius: "50%", objectFit: "inherit" }} variant="avatar" /> : getUserProfileIcon(time?.userId?.FirstName, time?.userId?.LastName)) : null}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="mb-0">{showUser ? `${time?.userId?.FirstName} ${time?.userId?.LastName}`.trim() : ""}</p>
                                                            <p className=" mt-0" style={{ color: titleHeader, overflowWrap: "break-word", wordBreak: "break-all" }}>{time?.description}</p>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="d-flex">{formattedDay}{" "}{formattedHours}{" "}{formattedMinutes}{" "}{formattedSeconds}</p>
                                                            <p className="mt-0">{moment(time?.createdAt).format('DD-MM-YY')}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    spentTime?.filter((time: { timeTaken: any; }) => time?.timeTaken)?.slice(0, 5)?.map((time: any, index: React.Key | null | undefined) => {
                                        const { hours, minutes, seconds, days } = convertMillisecondsToHoursMinutesSeconds(time?.timeTaken);
                                        const formattedDay = days > 0 ? `${days}d` : "";
                                        const formattedHours = hours > 0 ? `${hours}h` : "";
                                        const formattedMinutes = minutes > 0 ? `${minutes}m` : "";
                                        const formattedSeconds = seconds > 0 ? `${seconds}s` : "";
                                        const userId = time?.userId?._id || time?.userId;
                                        const showUser = userId && isUserInMasterData(userId);

                                        return (
                                            <div className="spenttime" key={index}>
                                                <div className="conatainer-fluid">
                                                    <div className="row">
                                                        <div className="col-md-2 m-0 d-flex">
                                                            {showUser ? (time?.userId?.ProfileImage ? <Image src={`${bucketUrl}${time?.userId?.ProfileImage}`} alt="" style={{ width: "50px", height: "40px", borderRadius: "50%", objectFit: "inherit" }} variant="avatar" /> : getUserProfileIcon(time?.userId?.FirstName, time?.userId?.LastName)) : null}
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="mb-0">{showUser ? `${time?.userId?.FirstName} ${time?.userId?.LastName}`.trim() : ""}</p>
                                                            <p className=" mt-0" style={{ color: titleHeader, overflowWrap: "break-word", wordBreak: "break-all" }}>{time?.description}</p>
                                                        </div>
                                                        <div className="col-md-5">
                                                            <p className="d-flex">{formattedDay}{" "}{formattedHours}{" "}{formattedMinutes}{" "}{formattedSeconds}</p>
                                                            <p className="mt-0">{moment(time?.createdAt)?.format('ll')}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>

                        </div>
                    </>
                )}
                {selectedTab === 'action' && (
                    <div>
                        <h5>Actions</h5>
                        <p className='text-muted'>All Actions</p>
                    </div>
                )}
            </div >
            <ActivityHistoryModal
                isOpen={modalOpen}
                toggle={toggleModal}
                items={items}
                hasMore={hasMore}
                fetchMoreData={fetchMoreData}
                dataForTable={dataForTable}
                colorMode={colorMode}
            />
            <ActivityRevertHistory isOpen={historyModalOpen} togglePopover={toggleHistoryModal} items={items}
                hasMore={hasMore}
                fetchMoreData={fetchMoreData}
                dataForTable={dataForTable}
                colorMode={colorMode}
                view="Project"
                projectId={projectId}
                page={next}
                limit={limit}
            />
            <ContractsListModal
                isOpen={isContractsListOpen}
                toggle={() => setIsContractsListOpen(!isContractsListOpen)}
                projectId={projectId}
                contracts={getproject?.contracts || []}
                salesReps={salesReps}
                colorMode={colorMode}
            />
            <div className='text-center col-md-1 p-3' style={{ borderLeft: `2px solid ${theme?.colors?.lightbackground}` }}>
                <div onClick={() => handleTabClick('activity')}>
                    <button className='btn' style={{ backgroundColor: selectedTab === 'activity' && colorMode === "light" ? `${theme?.colors?.lightbackground}` : selectedTab === 'activity' && colorMode === "dark" ? `#515568` : 'inherit' }}>
                        <Image src={activity} alt='' style={{ fill: selectedTab === 'activity' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />
                    </button>
                </div>
                <Text className='mt-2 ' sx={{ cursor: 'pointer' }}>Activity</Text>

                <ThreadModalPop handleTabClick={handleTabClick} selectedTab={selectedTab} phaseId={projectId} level="project" threads={getproject?.threads} />

                <div
                    onClick={() => {
                        dispatch(getAllContracts(projectId));
                        setIsContractsListOpen(true);
                    }}
                    className="d-flex flex-column align-items-center mt-2 p-2"
                    style={{ cursor: 'pointer' }}
                >
                    <button className='btn' style={{ backgroundColor: isContractsListOpen && colorMode === "light" ? `${theme?.colors?.lightbackground}` : isContractsListOpen && colorMode === "dark" ? `#515568` : 'inherit', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '12px' }}>
                        <LuFileText size={20} style={{ color: isContractsListOpen ? '#7743DB' : '#8F9195' }} />
                    </button>
                    <Text className='mt-1' sx={{ cursor: 'pointer' }}>Contracts</Text>
                </div>

                <div onClick={() => handleTabClick('spent')} >
                    <button className='btn ' style={{ backgroundColor: selectedTab === 'spent' && colorMode === "light" ? `${theme?.colors?.lightbackground}` : selectedTab === 'spent' && colorMode === "dark" ? `#515568` : 'inherit' }}>
                        <Image src={spent} alt='' style={{ fill: selectedTab === 'spent' ? `${theme?.colors?.lightbackground}` : 'inherit' }} />
                    </button>
                    <p className='mt-1' style={{ cursor: 'pointer' }}>Spent History</p>
                </div>
                <HistoryAction selectedTab={selectedTab} projectId={projectId} view={view} />

                <ProjectAction selectedTab={selectedTab} projectId={projectId} colorMode={colorMode} />
                {is_Super_Admin && <UpdateStatusToAny actionLists={projectStatuslist} levelStatus={"project"} updateStatusId={projectId} keyName={"projectId"} stagesView={[]} />}
            </div>
        </>
    )
};
export default ProjectSideActions;